import styled from '@emotion/styled'
import { AdminScope } from '@pubstack/common/src/scope'
import { FunctionComponent, PropsWithChildren } from 'react'
import { Colors } from '~/assets/style/colors'
import Button from '~/components/Button'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { PageContent } from '~/components/PageContent'
import { TabProp, Tabs } from '~/components/Tabs'
import { PureAdmContextKeysHelpFlyout } from './PureAdmContextHelpFlyout'

const ScopeDetailHeader = styled.div`
  position: sticky;
  top: 0;
  margin-bottom: 20px;
`

type PureAdmContextTabsProps = {
  currentScope?: AdminScope
  onTabClick: (tab: TabProp) => unknown
  tabs: TabProp[]
  breadcrumbs?: React.ReactNode
}
export const PureAdmContextTabs: FunctionComponent<PropsWithChildren<PureAdmContextTabsProps>> = ({ breadcrumbs, onTabClick, tabs, children }) => {
  const flyout = useGlobalFlyout()

  return (
    <PageContent
      breadcrumbs={breadcrumbs}
      headerActions={
        <Button
          variant={'tertiary'}
          iconName={'help'}
          onClick={() => flyout.open(PureAdmContextKeysHelpFlyout, { color: Colors.Violet, closeTrackingLabel: 'adm-contexts-help-close' })}
          trackingLabel={'adm-contexts-help'}
        >
          Help
        </Button>
      }
    >
      <ScopeDetailHeader>
        <Tabs tabs={tabs} onClick={onTabClick} />
      </ScopeDetailHeader>
      {children}
    </PageContent>
  )
}
